var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import './respiratory-monitoring-card.css';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import { RespiratoryMonitoringCardAPI } from '.';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType, TextAlignment } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { DateFormatterUtil } from '../../utils';
let RespiratoryMonitoringCard = class RespiratoryMonitoringCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, releaseDate, sequenceNumber } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        onClick,
                        releaseDate,
                        sequenceNumber
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus() {
        const { releaseDate } = this.props;
        if (releaseDate) {
            return React.createElement("div", { className: 'c-respiratory-monitoring-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-respiratory-monitoring-card__indicator-color-orange' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-respiratory-monitoring-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    getStatusIcon() {
        const { releaseDate } = this.props;
        if (releaseDate) {
            return React.createElement(ReleasedIcon, { className: 'c-respiratory-monitoring-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-respiratory-monitoring-card__color-orange' });
    }
    renderDefaultData() {
        const { dtMonitorizacao } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-respiratory-monitoring-card__header' },
                React.createElement("div", { className: 'c-respiratory-monitoring-card__hour' },
                    React.createElement(Text, { className: "c-text-hour", value: DateFormatterUtil.short(String(dtMonitorizacao)), alignment: TextAlignment.LEFT, bold: true })),
                React.createElement("div", { className: 'c-respiratory-monitoring-card__status' }, this.getStatusIcon())),
            React.createElement("div", { className: "c-component-separator" })));
    }
    renderData() {
        const { dsRespiracao, cdModVent, qtSaturacao, qtFio, qtFreqVent, qtFreqProg, qtAmplitude, qtPip, qtPeep, qtPva, qtFluxoInsp, qtTempoInsp, dsMusculo, qtOxidoNitrico, qtFluxoOxido, ieDispRespEsp, qtFluxoOxigenio, dsPadrao, dsEquipamento } = this.props;
        const listCardFieldProps = [
            { fieldCard: cdModVent, labelCard: 'tws.label-ventilator-mod' },
            { fieldCard: ieDispRespEsp, labelCard: 'tws.label-accessory-devices' },
            { fieldCard: dsMusculo, labelCard: 'tws.label-acessory-muscle' },
            { fieldCard: dsPadrao, labelCard: 'tws.label-default' },
            { fieldCard: dsRespiracao, labelCard: 'tws.label-respiration-type' },
            { fieldCard: dsEquipamento, labelCard: 'tws.label-equipment' },
            { fieldCard: qtAmplitude, labelCard: 'tws.label-amp' },
            { fieldCard: qtFio, labelCard: 'tws.label-wire' },
            { fieldCard: qtFluxoInsp, labelCard: 'tws.label-inspiratory-flow' },
            { fieldCard: qtFluxoOxido, labelCard: 'tws.label-oxide-flow' },
            { fieldCard: qtFluxoOxigenio, labelCard: 'tws.label-oxygen-flow' },
            { fieldCard: qtFreqProg, labelCard: 'tws.label-programmed-freq' },
            { fieldCard: qtFreqVent, labelCard: 'tws.label-prog-frequency' },
            { fieldCard: qtOxidoNitrico, labelCard: 'tws.label-nitric-oxide' },
            { fieldCard: qtPeep, labelCard: 'tws.label-peepcm' },
            { fieldCard: qtPip, labelCard: 'tws.label.pip' },
            { fieldCard: qtPva, labelCard: 'tws.label-pmva' },
            { fieldCard: qtSaturacao, labelCard: 'tws.label-sat' },
            { fieldCard: qtTempoInsp, labelCard: 'tws.label-inspiratory-time' }
        ];
        const listCardFieldPropsFiltered = listCardFieldProps.filter(items => items.fieldCard != null);
        return (React.createElement("div", { className: 'c-respiratory-monitoring-card__dynamic-data' }, listCardFieldPropsFiltered.map((items, index) => (React.createElement("div", { key: items.labelCard, className: 'c-respiratory-monitoring-card-content-item' },
            React.createElement("div", { className: 'c-respiratory-monitoring-card-content-label' },
                React.createElement(Text, { className: "c-text-label", bold: index % 2 !== 0, value: MessageService.translate(items.labelCard) })),
            React.createElement("div", { className: 'c-respiratory-monitoring-card-content-value' },
                React.createElement(Text, { className: "c-text-value", bold: index % 2 !== 0, value: String(items.fieldCard) })))))));
    }
    render() {
        const legends = [
            {
                color: 'signal-green-60',
                icon: React.createElement(ReleasedIcon, null),
                label: MessageService.translate('tws.label-released'),
                value: MessageService.translate('tws.label-released')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(PendingIcon, null),
                label: MessageService.translate('tws.label-pending'),
                value: MessageService.translate('tws.label-pending')
            }
        ];
        const { sequenceNumber } = this.props;
        return (React.createElement(Card, { className: 'c-respiratory-monitoring-card', uuid: generateUUID(), key: sequenceNumber, width: 12, selectionType: SelectionType.SINGLE, superscription: legends, onClick: () => this.handleClick() },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-respiratory-monitoring-card__wrapper' },
                this.renderDefaultData(),
                this.renderData())));
    }
};
RespiratoryMonitoringCard = __decorate([
    AwesomeComponent({ api: RespiratoryMonitoringCardAPI, type: ComponentType.DATA_DISPLAY })
], RespiratoryMonitoringCard);
export default RespiratoryMonitoringCard;
//# sourceMappingURL=respiratory-monitoring-card.js.map